// extracted by mini-css-extract-plugin
export default {"buttonAction":"PurchaseOrdersVendorTab_buttonAction__4-f-2","vendorTable":"PurchaseOrdersVendorTab_vendorTable__afKta"};